//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Tooling/Tooling.DefineNeutralFactorBuilder.js";
import "../no/SelectEdgeList.js";
import "../no/SelectFaceList.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AlternateResult",1,0],[0,"BaseBody",1,"Body",0],[0,"BendAngle1",1,0],[0,"BendAngle2",1,0],[0,"BendAngle3",1,0],[0,"BendAngle4",1,0],[0,"BendAngle5",1,0],[0,"BendDevLength",1,0],[0,"BendNeutralFactor",1,0],[0,"BendNumPrebends",1,0],[1,"DefineNeutralFactor",0,"Tooling.DefineNeutralFactorBuilder",0],[0,"FixTabFlangePosition",1,0],[0,"KeepRadiusFixed",1,0],[0,"OverbendAngle",1,0],[0,"OverbendOption",1,0],[0,"OverbendRadius",1,0],[1,"ReferObject",0,"SelectEdgeList",0],[0,"ResizeRadius",1,0],[0,"RestorePosition",1,0],[1,"SelectedBend",0,"SelectFaceList",0],[0,"Type",1,0],[1,"WorkPart",0,"Assemblies.SelectComponent",0]],[],[]];
SPLM.Tooling.BendOperationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BendOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BendOperationBuilder.Types = Object.freeze({
    "Unbend" : "Unbend", "Rebend" : "Rebend", "Prebend" : "Prebend", "Overbend" : "Overbend"});

SPLM.Tooling.BendOperationBuilder.Prebend = Object.freeze({
    "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six"});

SPLM.Tooling.BendOperationBuilder.OverbendOptions = Object.freeze({
    "ResizeBendAngle" : "ResizeBendAngle", "ResizeBendRadius" : "ResizeBendRadius"});

export default SPLM;